import React, { useEffect, useMemo, useState } from "react";
import MainNavigation from "../../components/navigation/MainNavigation";
import SideNavigation from "../../components/navigation/SideNavigation";
import { useAppDispatch } from "../../store";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { fetchFeedPagesItems } from "../../store/slices/feed";
import { v4 as uuidv4 } from "uuid";
import { CircleLoader } from "../../icons/Loaders";
import PagesStory from "../../components/story/PagesStory";
import DataNotAvailable from "../../components/errors/DataNotAvailable";
import {
  fetchActiveFeedItem,
  fetchActiveFeedItemCVI,
  fetchActiveFeedItemNumbers,
} from "../../store/slices/activeFeedItem";
import { useSearchParams } from "react-router-dom";

const Pages = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const items = useSelector((state: any) => state.feed.pagesData?.posts);
  const isLoading = useSelector((state: any) => state.feed.isLoading);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();

  const filters = [
    {
      filter: "Big",
      selected: false,
    },
    {
      filter: "Fast",
      selected: false,
    },
  ];

  useEffect(() => {
    if (!isLoading && items?.length === 0) {
      document.title = "Pages";
      document.body.dataset.titleReady = "true";
    }
  },[isLoading, items])

  useEffect(() => {
    const filter = searchParams.get('filter');
    const search = searchParams.get('q');

    setSearchTerm(search || "");
    setSelectedFilter(filter || "")

    dispatch(fetchFeedPagesItems(filter || "", search || ""));
  }, [dispatch]);

  const transformedItems = useMemo(() => {
    if (!items) return [];
    return items.map((e) => {
      return {
        ...e,
        type: "secondary",
        postId: e.post_id,
        pubDate: e.pubdate,
        key: uuidv4(),
      };
    });
  }, [items]);

  useEffect(() => {
    if (!id && transformedItems[0]?.postId) {
      navigate(`/pages/${transformedItems[0].postId}`, {replace : true});
    }
  }, [transformedItems, id, navigate]);

  useEffect(() => {
    if (!id) return;
    dispatch(
      fetchActiveFeedItem(id, {
        primaryStoryType: "landing",
      }),
    );
    dispatch(fetchActiveFeedItemCVI(id));
    dispatch(fetchActiveFeedItemNumbers(id, { primaryStoryType: "landing" }));
  }, [id, dispatch]);

  const pageContent = useMemo(() => {
    if (isLoading) {
      return (
        <div className="loader-container">
          <CircleLoader />
        </div>
      );
    }
    if (transformedItems.length === 0) {
      return <DataNotAvailable pageType="pages" />;
    }
    return <PagesStory />;
  }, [isLoading]);

  return (
    <div>
      <MainNavigation />
      <div className="container">
        <SideNavigation
          title="Pages"
          items={transformedItems}
          filters={filters}
          hasSearch
          isLoading={isLoading}
          filtersMessage="Sort pages by"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          fetchFunction={fetchFeedPagesItems}
          searchFunction={fetchFeedPagesItems}
        />
        <div className="main-page-container">{pageContent}</div>
      </div>
    </div>
  );
};

export default Pages;
